export default function releaseMediaElement(element: HTMLVideoElement | null) {
  if (!element) return;

  element.pause();
  element.src = '';
  element.load();
}
